import * as types from '../costants/ActionTypes'
import {CART_URL, CLEAR_CART_URL, DEL_ITEMS_URL, UPDATE_ITEMS_URL, CHECKOUT_URL} from "../costants/Urls";
import axios from 'axios'
import {setResultData} from "./nResultActions";
import {setShippingData, setShippingStatus} from "./nShippingActions";
import {setUserData} from "./nUserActions";
import {setPaymentData} from "./nPaymentActions";

export const setCartState = status => ({
  type: types.SET_CART_STATE,
  status
});

export const setCartData = data => ({
  type: types.SET_CART_DATA,
  data
});

export const resetCartData = data => ({
  type: types.RESET_CART_DATA,
  data
});

export const setCartItemData = data => ({
  type: types.SET_CART_ITEM_DATA,
  data
});

export const removeCartItem = item_id => ({
  type: types.DELETE_CART_ITEM,
  item_id: item_id
});

const post_config = {
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-CSRFToken',
        withCredentials: true
      }

// Обновление данных элементов корзины
export const fetchCartItems = status =>  (dispatch, getState) => {

    const loading_state = getState().ncart.status;

    if (loading_state==="NOT_LOADED"){

        dispatch(setCartState('FETCHING'));

        axios.get(CART_URL, {})
          .then(res => {

            if (res.status === 200 || res.status === 201){

                dispatch(setCartData(res.data));

                if(res.data.shipping){

                    dispatch(setShippingData(res.data.shipping));
                    dispatch(setShippingStatus('READY'));

                }
                if(res.data.user){

                    dispatch(setUserData(res.data.user));

                }

                if(res.data.payment){
                    dispatch(setPaymentData(res.data.payment));

                }

                dispatch(setCartState('READY'));

            }else{

                dispatch(setCartState('ERROR'));

            }

          })
          .catch(err => {

            dispatch(setCartState('ERROR'));

          });
    }

};

// Удаление элемента корзины
export const delCartItem = productId => (dispatch, getState) => {

  const prev_state = getState()
  const productItem = prev_state.ncart.items.find(x => x.id === productId)

  if ((productItem !== undefined)&&(prev_state.ncart.status==="READY")) {

    const url = UPDATE_ITEMS_URL + productItem.id + '/';

    dispatch(setCartState('FETCHING'));

    axios.delete(url, post_config).then( res => {

     if (res.status === 200 || res.status === 201){

          dispatch(setCartData(res.data));
          dispatch(removeCartItem(productItem.id));
          dispatch(setCartState('READY'));

        }else{

          dispatch(setCartState('ERROR'));

        }

    }).catch(err=> {

        dispatch(setCartState('ERROR'));

    })

  }

}

// Очистка корзины
export const clearCart = () =>  (dispatch, getState) => {

  const url = CLEAR_CART_URL;
  const loading_state = getState().ncart.status;

  if (loading_state==='READY'){

      dispatch(setCartState('FETCHING'));

      axios.delete(url, post_config).then( res => {

         if (res.status === 200 || res.status === 201){

              dispatch(setCartData(res.data));
              dispatch(setCartState('READY'));

            }else{

              dispatch(setCartState('ERROR'));

            }
      }).catch(err=> {

            dispatch(setCartState('ERROR'));
      })
  };

};

// Изменение активности товара
export const checkCartItem = (productId, checked) => (dispatch, getState) => {

    const prev_state = getState()
    const productItem = prev_state.ncart.items.find(x => x.id === productId)

    if ((productItem !== undefined) && (productItem.checked !== checked) && (prev_state.ncart.status === "READY")) {

        const url = DEL_ITEMS_URL + productItem.id + '/';
        dispatch(setCartState('FETCHING'));

        axios.patch(url, {'checked': checked}, post_config).then( res => {

            if (res.status === 200 || res.status === 201){

                  dispatch(setCartData(res.data.cart));
                  dispatch(setCartItemData(res.data.cart_item));
                  dispatch(setCartState('READY'));

                }else{

                  dispatch(setCartState('ERROR'));

                }
            }).catch(err=> {

                dispatch(setCartState('ERROR'));

            })
    }
}

// Обновление количества товара
export const updateCartItemQuantity = (product, quantity) => (dispatch, getState) => {

    const url = UPDATE_ITEMS_URL + product.id + '/';
    dispatch(setCartState('FETCHING'));

    axios.patch(url, {'quantity': quantity}, post_config).then( res => {

        if (res.status === 200 || res.status === 201){

              dispatch(setCartData(res.data.cart));
              dispatch(setCartItemData(res.data.cart_item));
              dispatch(setCartState('READY'));
              //

        }else{

          dispatch(setCartState('ERROR'));

        }
    }).catch(err=> {

        dispatch(setCartState('ERROR'));

    })

}


// Изменение активности товара
export const checkoutCart = (data) => (dispatch, getState) => {

    const prev_state = getState()

    if ((prev_state.nshipping.status === "READY") && (prev_state.ncart.status === "READY")) {

        const url = CHECKOUT_URL;
        dispatch(setCartState('FETCHING'));

        axios.post(url, data, post_config).then( res => {

            if (res.status === 200 || res.status === 201){

                  dispatch(setCartData(res.data.cart));
                  dispatch(setResultData(res.data.result));
                  dispatch(setCartState('READY'));

                }else{

                  dispatch(setCartState('ERROR'));
                  dispatch(setResultData(res.data.result));

                }
            }).catch(err=> {

                dispatch(setCartState('ERROR'));

            })
    }
}